module.exports = __webpack_public_path__ + "img/TD.30aefef6.svg";